import { inject, Injectable } from '@angular/core';
import { ToastService as LDSToastService, ToastConfig } from '@circlek-global/lds-components';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly ldsToastService = inject(LDSToastService);
  private readonly translate = inject(TranslateService);
  private readonly defaultToastConfig: ToastConfig = {
    duration: 5000,
  };

  private getTranslationWithFallback(mainKey: string, fallbackKey: string) {
    const mainTranslation = this.translate.instant(mainKey);

    return mainTranslation === mainKey ? this.translate.instant(fallbackKey) : mainTranslation;
  }

  showError(messageTransKey: string) {
    const message = this.getTranslationWithFallback(messageTransKey, 'something_went_wrong');

    this.ldsToastService.error(message, '', this.defaultToastConfig);
  }

  showSuccess(messageTransKey: string) {
    const message = this.getTranslationWithFallback(messageTransKey, 'DEFAULT_SUCCESS_KEY');

    this.ldsToastService.success(message, '', this.defaultToastConfig);
  }
}
